import { useBookkeepingItems, UseBookkeepingItemsParams } from '@features/reconciliation/hooks/useBookkeepingItems'

import { useSandboxModeContext } from '../contexts/sandboxModeContext'

/**
 * Thin wrapper around useBookkeepingItems that threads the sandbox override through from
 * context, so call sites inside this page tree don't each have to read the context and
 * build the option object themselves.
 */
export const useSandboxBookkeepingItems = (params: UseBookkeepingItemsParams) => {
  const sandbox = useSandboxModeContext()
  const result = useBookkeepingItems({
    ...params,
    enabled: !sandbox && params.enabled,
  })

  return sandbox ? { items: sandbox.sandboxState.bookkeepingItems, isLoading: false, isError: false } : result
}
